{
  "de": {
    "decision_type": {
      "actions": {
        "add_competitor": "Wettbewerber hinzufügen",
        "add_decision_partners": "Entscheidungspartner",
        "auto_share_proposals": "Genehmigte Angebote automatisch teilen",
        "change_rights": "Rechte ändern",
        "collapse": "Einklappen",
        "create_category": "Neue Kategorie hinzufügen",
        "delete": "Löschen",
        "deleteMultiple": "Löschen …",
        "delete_cancel": "Abbrechen",
        "delete_group": "Partnergruppe löschen",
        "download": "Herunterladen",
        "edit": "Bearbeiten",
        "edit_decision_partners": "Entscheidungspartner bearbeiten",
        "import": "Importieren",
        "manage": "Verwalten",
        "new": "Neu",
        "newDecision": "Neue Entscheidung",
        "newDecisions": "Entscheidung",
        "save": "Speichern",
        "show": "Anzeigen",
        "start_new_group": "Neue Gruppe starten",
        "submit": "Absenden"
      },
      "attributes": {
        "category": "Kategorie",
        "created_at": "Erstellt am",
        "description": "Beschreibung",
        "name": "Titel",
        "responsible": "Verantwortlich",
        "start_date": "Startdatum"
      },
      "labels": {
        "add_decision_partners": "Entscheidungspartner hinzufügen",
        "allowCreditExplainer": "Gutschrift für Angebote unter dem Budget anzeigen",
        "auto_close": "Entscheidung automatisch schließen, sobald die Frist abgelaufen ist",
        "auto_close_info": "Das Schließen einer Entscheidung verhindert, dass der Kunde ein Angebot genehmigt, wenn noch keine Entscheidung getroffen wurde. Das ist nützlich, wenn Sie mit knappen Fristen arbeiten.",
        "auto_share": "Automatisch teilen",
        "auto_share_description": "Genehmigte Angebote automatisch mit dieser Partnergruppe teilen",
        "auto_share_subtitle": "Wenn ein neues Angebot genehmigt wird",
        "auto_share_title": "Genehmigte Angebote automatisch teilen",
        "category_name": "Kategoriename",
        "closes_on_deadline": "Schließt bei Fristablauf",
        "createNewPartner": "Oder neuen Entscheidungspartner erstellen",
        "decision_type_category_description": "Wenn Sie mehreren Entscheidungen eine Kategorie wie Küche, Badezimmer usw. zuweisen, werden diese gruppiert und lassen sich besser überblicken",
        "deleteCategory": "Kategorie {category} löschen?",
        "deleteGroupSubtitle": "Dadurch werden alle Konversationen, Angebote und Dokumente entfernt, die von allen Mitgliedern von {group_name} in {decision_type_name} erstellt wurden.",
        "deleteGroupTitle": "Sie sind dabei, {group_name} zu löschen",
        "disclaimerDeleteGroup": "Das Löschen von {group_name} hebt die Veröffentlichung aller Entscheidungen für die Entscheidungspartner auf. Sie können erneut für Entscheidungspartner veröffentlichen, sobald diese Entscheidung wieder Entscheidungspartner hat.",
        "disclamerDeleteCategory": "Das Löschen von {category} entfernt die Kategorie von allen zugewiesenen Entscheidungen. Die Entscheidungen selbst werden nicht gelöscht.",
        "editCategory": "Kategorie bearbeiten",
        "editGroup": "{group_name} bearbeiten",
        "editPartnerRights": "Kommunikationsrechte der Entscheidungspartner bearbeiten",
        "editPartnerRightsLater": "Sie können dies jederzeit später ändern",
        "edit_partner_group_eyebrow": "Partnergruppe bearbeiten",
        "existing_groups": "Bestehende Partnergruppen",
        "explainerPartners": "Fügen Sie externe Entscheidungspartner hinzu und arbeiten Sie gemeinsam an {decision_type_name}",
        "export_preparing": "Das Zusammenstellen aller Angebote kann einige Minuten dauern. Sie erhalten eine Benachrichtigung, sobald der Download bereit ist.",
        "export_proposals_approved": "Dokumente genehmigter Angebote",
        "for_decision": "Für Entscheidung",
        "groupRightsWarning": "Achtung! Alle Konversationen zwischen dem Kunden und den Partnern werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?",
        "hint": "Sie können Ihre Kategorien in den",
        "hintSettings": "Organisationseinstellungen verwalten.",
        "last_updated_at": "Zuletzt aktualisiert am",
        "matrix": "Statistiken",
        "new_category": "Neue Entscheidungskategorie",
        "new_partner_group": "Neue Partnergruppe",
        "noPartnersAddedYet": "Noch keine Entscheidungspartner hinzugefügt",
        "noResultPartner": "Keine Ergebnisse für {partner_name}",
        "partner_already_in_other_group": "Bereits in anderer Gruppe",
        "partner_already_selected": "Bereits ausgewählt",
        "partner_group": "Partnergruppe",
        "partner_group_footer_empty": "Mindestens 1 Partner auswählen",
        "partner_group_footer_summary": "{count} Partner • {rights} | {count} Partner • {rights} | {count} Partner • {rights}",
        "partner_group_name_label": "Name der Partnergruppe",
        "partner_groups": "Partnergruppen",
        "partners": "Entscheidungspartner",
        "partners_count": "Keine Partner | 1 Partner | {count} Partner",
        "partners_in_group": "Partner in dieser Gruppe",
        "partners_in_total": "Insgesamt keine Partner | Insgesamt 1 Partner | Insgesamt {count} Partner",
        "partners_selected_count": "Keine ausgewählt | 1 ausgewählt | {count} ausgewählt",
        "permissions_label": "Gruppenrechte",
        "projectUnitsTotal": "{project_name} hat insgesamt {units_count_max} Einheiten",
        "proposal_uploaded": "Angebot hochgeladen",
        "published_state": "Veröffentlichungsstatus",
        "searchPartners": "Entscheidungspartner suchen",
        "selectADecision": "Eine Entscheidung auswählen",
        "select_decision_partners": "Wählen Sie Ihre Entscheidungspartner aus",
        "setUpPartners": "Entscheidungspartner einrichten",
        "set_rights": "Gruppenrechte für {partner_group_name} festlegen",
        "share_existing_title": "Bestehende Angebote teilen",
        "share_proposals_label": "Angebote teilen",
        "start_date_description": "Datum nur für internen Gebrauch. Es kann verwendet werden, um die Reihenfolge festzulegen, in der Ihr Team die Entscheidungen bearbeitet",
        "start_date_title": "Startdatum (optional)",
        "step0Title": "Welches Vorlagenprojekt und welche Entscheidung möchten Sie verwenden?",
        "step1Title": "Welche Art von Entscheidung müssen Ihre Kunden treffen?",
        "tab_proposal_templates": "Angebotsvorlagen",
        "tab_units": "Einheiten",
        "upsellCategoryTypes": "Diese Funktion ist nicht in Ihrem Paket enthalten. Kontaktieren Sie uns über die blaue Schaltfläche, um mehr zu erfahren.",
        "view": "Ansicht",
        "view_list": "Liste",
        "view_table": "Tabelle",
        "writeEmployeeNameReject": "Schreiben Sie <i><b>{employeeName}</b></i>, um fortzufahren."
      },
      "snackbars": {
        "duplicate": "Die Entscheidung wurde erstellt, der Kopiervorgang aus der Vorlage kann jedoch noch einige Minuten dauern."
      },
      "toasts": {
        "bulk_delete": "Entscheidung wurde erfolgreich gelöscht | Entscheidungen wurden erfolgreich gelöscht",
        "update": "Entscheidung wurde erfolgreich aktualisiert"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "„{name}“ ist für dieses Projekt bereits vergeben",
        "nameAlreadyTaken": "Der Name ist für dieses Projekt bereits vergeben",
        "needName": "Titel ist erforderlich",
        "projectRequired": "Wählen Sie zuerst ein Projekt aus",
        "selectDecisionType": "Mindestens 1 Entscheidung auswählen",
        "selectSharingOption": "Wählen Sie aus, mit wem Sie das/die Dokument(e) teilen möchten"
      }
    }
  }
}
